import {TORRESOWO_URL} from "./consts";

export async function setViewEpisode({uid, serieId, season_number, episode_number, view = true}) {

    return fetch( `${TORRESOWO_URL}/tmdb/mark-as-view/${serieId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            uid,
            season_number,
            episode_number,
            view
        }),
    });
}

export async function saveTmdbNote({uid, tmdbId, season_number, episode_number, notes}) {
    return fetch( `${TORRESOWO_URL}/tmdb/save-notes/${tmdbId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            uid,
            season_number,
            episode_number,
            notes
        }),
    });
}

export async function markAsViewLater({uid, tmdbId, season_number, episode_number, view_later = true}) {
    return fetch( `${TORRESOWO_URL}/tmdb/mark-to-view-later/${tmdbId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            uid,
            season_number,
            episode_number,
            view: view_later
        }),
    });
}

export async function getLastSeenEpisode(uid, serieId) {
    const res = await fetch(`${TORRESOWO_URL}/tmdb/last-seen-episode/${serieId}?uid=${uid}`);
    return await res.json();
}
